module.exports = __webpack_public_path__ + "img/edit-transport.83b43c72.png";